import { MODAL_CLOSE_TIMEOUT_NONE } from '@porterin/feature/src/shared/modal/domain/entities/ModalEntities';
import React from 'react';
import ReactModal from 'react-modal';

import styles from '../styles/PnMCallbackConfirmationModal.module.scss';

import PnMCallbackConfirmationCmp from './PnMCallbackConfirmationCmp';

interface PnMCallbackConfirmationModalCmpProps {
  modal_state: boolean;
  close_modal: () => void;
}

function PnMCallbackConfirmationModalCmp({
  modal_state,
  close_modal,
}: Readonly<PnMCallbackConfirmationModalCmpProps>): React.ReactElement {
  return (
    <ReactModal
      isOpen={modal_state}
      onRequestClose={close_modal}
      closeTimeoutMS={MODAL_CLOSE_TIMEOUT_NONE}
      overlayClassName={styles['overlay']}
      className={styles['modal-container']}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <PnMCallbackConfirmationCmp close_modal={close_modal} />
    </ReactModal>
  );
}

export default PnMCallbackConfirmationModalCmp;
